const updates = [
  {
    date: '2026.08.01',
    title: '《偶像练习生2026》最新舞台纯享版上线',
    desc: '本季偶像练习生最燃舞台合集已更新，1080P高清画质，不缓冲不卡顿流畅播放。',
    type: '上新',
  },
  {
    date: '2026.07.30',
    title: '热门真人秀《极限挑战王》全集已收录',
    desc: '户外挑战型真人秀极限挑战王全集高清免费在线观看，偶像团体倾情参与。',
    type: '更新',
  },
  {
    date: '2026.07.28',
    title: '平台播放体验全面优化升级',
    desc: '视频加载速度提升40%，移动端适配更加流畅，带来更好的高清观影体验。',
    type: '优化',
  },
  {
    date: '2026.07.25',
    title: '新增多个偶像团体综艺专题',
    desc: '本月新增15个偶像团体专属综艺专题，覆盖选秀、旅行、音乐等多元题材。',
    type: '上新',
  },
  {
    date: '2026.07.22',
    title: '《音乐舞台纯享版》系列持续热播',
    desc: '爱豆团体打歌舞台纯享版播放量突破千万，高清画质获观众一致好评。',
    type: '热门',
  },
  {
    date: '2026.07.20',
    title: '幕后花絮频道正式上线',
    desc: '全新幕后花絮频道上线，独家探班内容、拍摄现场花絮，近距离了解偶像日常。',
    type: '上新',
  },
  {
    date: '2026.07.18',
    title: 'CDN节点扩容，全网流畅加速',
    desc: '完成全国CDN节点扩容，确保各地用户都能享受不缓冲不卡顿的流畅播放体验。',
    type: '优化',
  },
  {
    date: '2026.07.15',
    title: '《旅行综艺全记录》新一季开播',
    desc: '跟随偶像团体环游世界，全新旅行综艺全记录高清上线，治愈系内容不容错过。',
    type: '上新',
  },
  {
    date: '2026.07.12',
    title: '用户反馈通道全面开放',
    desc: '新增用户反馈入口，您的每一条建议都将帮助我们打造更好的追综平台。',
    type: '公告',
  },
];

function getTypeStyles(type: string) {
  switch (type) {
    case '上新':
      return 'bg-primary-100 text-primary-700';
    case '更新':
      return 'bg-accent-100 text-accent-700';
    case '优化':
      return 'bg-secondary-100 text-secondary-700';
    case '热门':
      return 'bg-accent-100 text-accent-700';
    default:
      return 'bg-background-200 text-foreground-600';
  }
}

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          爱豆影视内容更新与平台动态一览
        </p>
        <div className="relative pl-8 border-l-2 border-background-200 space-y-6">
          {updates.map((item, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[calc(2rem+5px)] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-400 ring-4 ring-background-50"></div>
              <div className="bg-background-100 rounded-lg border border-background-200/70 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${getTypeStyles(item.type)}`}>
                    {item.type}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}